import React from 'react';
import { Field } from 'formik';
import { Box } from 'lmc-ui-library';
import { FIELDS, FIELDS_LABELS, RADIO_VALUES } from 'screens/Panel/screens/User/screens/Edit/Edit.types';

import styles from 'screens/Panel/screens/User/screens/Edit/Edit.module.scss';

const Status = () => {
  return (
    <Box title="Status" className={styles.box}>
      <Box.Content>
        <label className={styles.label}>FCA status</label>
        <div className={styles.radioContainer} role="group" aria-labelledby={FIELDS_LABELS.FCA_STATUS}>
          <label>
            <Field
              type="radio"
              name={FIELDS.FCA_STATUS}
              value={RADIO_VALUES.ACTIVE}
              className={styles.radioBtn}
              disabled={true}
            />
            <span className={styles.customRadio} />
            Active
          </label>
          <label>
            <Field
              type="radio"
              name={FIELDS.FCA_STATUS}
              value={RADIO_VALUES.INACTIVE}
              className={styles.radioBtn}
              disabled={true}
            />
            <span className={styles.customRadio} />
            Inactive
          </label>
        </div>

        <label className={styles.label}>{FIELDS_LABELS.LMC_STATUS}</label>
        <div className={styles.radioContainer} role="group" aria-labelledby={FIELDS_LABELS.LMC_STATUS}>
          <label>
            <Field
              type="radio"
              name={FIELDS.LMC_STATUS}
              value={RADIO_VALUES.ACTIVE}
              className={styles.radioBtn}
              disabled={true}
            />
            <span className={styles.customRadio} />
            Active
          </label>
          <label>
            <Field
              type="radio"
              name={FIELDS.LMC_STATUS}
              value={RADIO_VALUES.INACTIVE}
              className={styles.radioBtn}
              disabled={true}
            />
            <span className={styles.customRadio} />
            Inactive
          </label>
        </div>
      </Box.Content>
    </Box>
  );
};

export default Status;
